module.exports = __webpack_public_path__ + "static/rug-of-smothering-mtg_clb-d17fb3c56a83fc9abc60916dc9c393c0.jpg";